import { Component, OnInit } from '@angular/core';
import { QrCodeService } from 'src/app/core/services/qr-input-service/qr-input.service';

@Component({
  selector: 'app-panther-lake-va-page',
  templateUrl: './panther-lake-va-page.component.html',
  styleUrls: ['./panther-lake-va-page.component.scss']
})
export class PantherLakeVAPageComponent implements OnInit {

  constructor(
    private qrCodeService: QrCodeService
  ) { }

  ngOnInit(): void {
    if (!this.qrCodeService.initialVALoad) {
      const vaUserInpu = this.qrCodeService.vaUserInput;
      if (vaUserInpu) {
        window.dispatchEvent(new CustomEvent('SEND_USER_MSG', { detail: vaUserInpu}));
      } else {
         window.dispatchEvent(new CustomEvent('OPEN_AI_BOT',{ detail: "OPEN_CHATBOT"}));
      }
      this.qrCodeService.vaUserInput = '';
    } else{
      this.qrCodeService.initialVALoad = false;
    }
  }

  ngOnDestroy(): void {
    window.dispatchEvent(new CustomEvent('VA_TAB_EXIT_EVENT', { detail: true }));
  }
}
